var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinButton4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_826_14302)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint0_radial_826_14302)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint1_radial_826_14302)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint2_radial_826_14302)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint3_radial_826_14302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9797 52.7305V55.2109H42.2219V60.9141H39.1164V55.2109H32.4953V52.7305H48.9797ZM34.3117 51.1094V43.6875H47.1242V51.1094H34.3117ZM37.3781 48.668H43.9992V46.1484H37.3781V48.668ZM65.0844 56.5391V59.0781H48.5805V56.5391H52.5453V54.1953H50.3773V47.8086H60.2016V46.4414H50.3578V43.9414H63.307V50.2695H53.5219V51.6758H63.7172V54.1953H61.3539V56.5391H65.0844ZM55.5922 56.5391H58.268V54.1953H55.5922V56.5391ZM65.0758 56.7539V53.8633L70.7984 44.8594H75.5055V53.8438H77.1461V56.7539H75.5055V59H71.9508V56.7539H65.0758ZM68.7477 53.8438H72.0289V48.7266H71.9117L68.7477 53.7461V53.8438ZM92.4305 42.8672V60.9336H89.325V42.8672H92.4305ZM77.0984 55.6602C78.368 55.6602 79.8133 55.6602 81.3367 55.6309V54.3613C79.491 53.9414 78.2898 52.7109 78.2898 51.1094C78.2898 49.0977 80.1941 47.6914 82.8797 47.6914C85.6043 47.6914 87.5379 49.0977 87.5477 51.1094C87.5379 52.7012 86.327 53.9316 84.4617 54.3613V55.5234C85.8191 55.4453 87.1668 55.3281 88.4656 55.1523L88.6609 57.457C84.784 58.1602 80.6336 58.1895 77.4891 58.1797L77.0984 55.6602ZM77.45 47.1836V44.7617H81.3367V43.0039H84.4813V44.7617H88.3484V47.1836H77.45ZM81.2781 51.1094C81.2781 51.8613 81.952 52.1836 82.8797 52.1836C83.8855 52.1836 84.5398 51.8613 84.5398 51.1094C84.5398 50.3867 83.8855 50.0547 82.8797 50.0352C81.952 50.0547 81.2781 50.3867 81.2781 51.1094ZM53.2332 70.6367V73.0586H48.4871V73.8984H55.1668V76.3398H38.6824V73.8984H45.323V73.0586H40.6551V67.4141H53.116V69.8945H43.7605V70.6367H53.2332ZM40.5184 84.8555V79.7773H50.1277V79.2109H40.5379V76.9453H53.2137V81.9062H43.5848V82.5117H53.6434V84.8555H40.5184ZM70.041 66.8672V84.9922H66.916V66.8672H70.041ZM55.6855 80.8516V73.1562H61.1738V70.793H55.6855V68.293H64.377V75.5977H58.9277V78.3027C61.5059 78.2734 63.625 78.1172 65.9199 77.7266L66.1738 80.2461C63.4395 80.7637 60.8027 80.8613 57.3848 80.8516H55.6855ZM86.1848 66.8672V84.9336H83.0012V66.8672H86.1848ZM70.8137 79.5625C75.3156 77.4238 77.1223 74.9434 77.5324 71.1641H71.8488V68.7227H80.716C80.7258 74.377 79.1242 78.8984 72.4152 82.0234L70.8137 79.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_826_14302",
    x: -4,
    y: 0,
    width: 135.04,
    height: 135.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_826_14302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_826_14302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_826_14302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_826_14302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_826_14302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_826_14302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinButton4);
export default __webpack_public_path__ + "static/media/spin-button4.f60231a8c3a872f88805bf06a14ec06c.svg";
export { ForwardRef as ReactComponent };